export interface HttpOptions {
  url?: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';
  headers?: Record<string, string>;
  body?: string | FormData | URLSearchParams | Uint8Array ;
  timeout?: number;
  params?: Record<string, unknown>;
}

export interface HttpError extends Error {
  status?: number;
  statusText?: string;
  /** 重试动作 */
  action?: 'RETRY' | 'CONTINUE';
  /** 错误代码 */
  code?: string;
}

/**
 * HTTP错误代码枚举 - 参考 adjust web sdk 错误分类
 */
export enum HttpErrorCode {
  NO_CONNECTION = 'NO_CONNECTION',
  SERVER_CANNOT_PROCESS = 'SERVER_CANNOT_PROCESS',
  SERVER_MALFORMED_RESPONSE = 'SERVER_MALFORMED_RESPONSE',
  SERVER_INTERNAL_ERROR = 'SERVER_INTERNAL_ERROR',
  TRANSACTION_ERROR = 'TRANSACTION_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  PARSE_ERROR = 'PARSE_ERROR',
  PROTOBUF_ERROR = 'PROTOBUF_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  SKIP = 'SKIP',
  MISSING_URL = 'MISSING_URL'
}

// ==================== 重试相关类型 ====================

/**
 * 重试配置接口 - 参考 adjust web sdk 设计
 */
export interface RetryConfig {
  /** 最大重试次数 */
  maxRetries: number;
  /** 重试前回调函数 */
  onRetry?: (error: HttpError, attempt: number) => void;
  /** 重试失败回调函数 */
  onRetryFailed?: (error: HttpError, attempts: number) => void;
}

/**
 * 带重试的HTTP请求配置 - 参考 adjust web sdk 设计
 */
export interface HttpWithRetryOptions extends HttpOptions {
  /** 重试配置 */
  retry?: Partial<RetryConfig>;
  /** 是否启用重试 */
  enableRetry?: boolean;
  /** 网络状态检查 */
  checkNetworkStatus?: boolean;
}

/**
 * 带重试的HTTP响应接口
 */
export interface HttpWithRetryResponse {
  data: Response;
  /** 重试信息 */
  retryInfo?: RetryInfo;
}

/**
 * 重试信息接口
 */
export interface RetryInfo {
  /** 总尝试次数（包括初始请求） */
  attempts: number;
  /** 总耗时（毫秒） */
  totalTime: number;
  /** 是否成功 */
  success: boolean;
  /** 连接重试次数 */
  connectionRetries: number;
  /** 请求重试次数（非连接错误） */
  requestRetries: number;
}
